"use strict";

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grabber = void 0;

var Utils_1 = require("../../../Utils");

var Enums_1 = require("../../../Enums");

var ExternalInteractorBase_1 = require("../../../Core/ExternalInteractorBase");

var Grabber =
/*#__PURE__*/
function (_ExternalInteractorBa) {
  _inherits(Grabber, _ExternalInteractorBa);

  function Grabber(container) {
    _classCallCheck(this, Grabber);

    return _possibleConstructorReturn(this, _getPrototypeOf(Grabber).call(this, container));
  }

  _createClass(Grabber, [{
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container,
          mouse = container.interactivity.mouse,
          events = container.actualOptions.interactivity.events;
      return events.onHover.enable && !!mouse.position && (0, Utils_1.isInArray)(Enums_1.HoverMode.grab, events.onHover.mode);
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function interact() {
      var _a;

      var container = this.container,
          options = container.actualOptions,
          interactivity = options.interactivity;

      if (interactivity.events.onHover.enable && container.interactivity.status === Utils_1.Constants.mouseMoveEvent) {
        var mousePos = container.interactivity.mouse.position;

        if (!mousePos) {
          return;
        }

        var distance = container.retina.grabModeDistance,
            query = container.particles.quadTree.queryCircle(mousePos, distance);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = query[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var particle = _step.value;
            var pos = particle.getPosition(),
                pointDistance = (0, Utils_1.getDistance)(pos, mousePos);

            if (pointDistance <= distance) {
              var grabLineOptions = interactivity.modes.grab.links,
                  lineOpacity = grabLineOptions.opacity,
                  opacityLine = lineOpacity - pointDistance * lineOpacity / distance;

              if (opacityLine <= 0) {
                continue;
              }

              var optColor = (_a = grabLineOptions.color) !== null && _a !== void 0 ? _a : particle.options.links.color;

              if (!container.particles.grabLineColor) {
                var linksOptions = options.interactivity.modes.grab.links;
                container.particles.grabLineColor = (0, Utils_1.getLinkRandomColor)(optColor, linksOptions.blink, linksOptions.consent);
              }

              var colorLine = (0, Utils_1.getLinkColor)(particle, undefined, container.particles.grabLineColor);

              if (!colorLine) {
                return;
              }

              container.canvas.drawGrabLine(particle, colorLine, opacityLine, mousePos);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  }]);

  return Grabber;
}(ExternalInteractorBase_1.ExternalInteractorBase);

exports.Grabber = Grabber;